import React from "react"
import styled from "styled-components"
import StatisticIcon from "../../../assets/svgs/statistic.svg"
import Supervisor from "./Supervisor"

const PositionContainer = styled.div`
  position: relative;
  box-shadow: rgb(122, 121, 121, 0.2) 0px 0px 0px 1px,
    0px 4px 10px rgba(0, 0, 0, 0.15);
  background: #ffffff;
  width: 264px;

  @media (min-width: 40em) {
    width: min(100%, 450px);
  }

  @media (min-width: 64em) {
    margin-top: 6rem;
    width: 264px;
    margin-right: auto;
  }
`

const PositionLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 2rem 2rem;
  gap: 0.5rem;
  isolation: isolate;

  @media (min-width: 40em) {
    flex-direction: row;
  }

  @media (min-width: 64em) {
    flex-direction: column;
  }
`

const IconContainer = styled.div`
  position: relative;
  left: 25px;
  top: -15px;
`

const Statistics = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Title = styled.h2`
  font-size: 1.5em;
  font-weight: 700;
  font-family: var(--ff-secondary);
  color: var(--clr-text-blue);
  line-height: 39px;
  margin-bottom: 0.5rem;
`

const Salary = styled.h3`
  font-size: 1.5em;
  font-weight: 800;
  font-family: var(--ff-secondary);
  color: var(--clr-text-blue);
  line-height: 39px;
  margin-bottom: 0.5rem;
`
const AverageParagraph = styled.div`
  font-style: normal;
  font-family: var(--ff-primary);
  font-weight: 400;
  font-size: 0.625rem;
  text-align: left;
  color: var(--clr-text-blue);
  line-height: 15px;
  letter-spacing: 0.004em;
`

const Date = styled(AverageParagraph)`
  display: contents;
`

const PositionFacts = ({
  image,
  supervisor,
  salary,
  salaryDate,
  rate,
  rateDate,
}) => {
  return (
    <PositionContainer>
      <IconContainer>
        <StatisticIcon />
      </IconContainer>
      <PositionLayout>
        <Statistics>
          <Title>Position facts</Title>
          <AverageParagraph>Average salary</AverageParagraph>
          <Salary>
            {salary} <Date>{salaryDate}</Date>
          </Salary>
          <AverageParagraph>Average billable rate</AverageParagraph>
          <Salary>
            {rate} <Date>{rateDate}</Date>
          </Salary>
        </Statistics>
        <Supervisor image={image} supervisor={supervisor} />
      </PositionLayout>
    </PositionContainer>
  )
}

export default PositionFacts
